<!--
 * @Descripttion: 个人中心-员工福利
 * @Author: liaoyijun
 * @Date: 2021-09-22 11:13:10
 * @LastEditors: chenjinsheng
 * @LastEditTime: 2021-11-11 11:00:28
-->
<template>
    <div :class="{ 'user-guide-benefit-box': steps.step5 }">
        <div class="offer-title">
            <div>
                <span>员工福利</span>
            </div>
        </div>
        <div class="offer-center">
            <div class="offer-center-right">
                <div class="offer-center-right-item" @click="goInside">
                    <div class="offer-center-right-item-title">
                        <span>内部福利</span>
                    </div>
                    <div class="offer-center-right-item-text">
                        <span>公司为员工提供的法定福利、常规福利、工会福利、外派福利</span>
                    </div>

                    <div class="study-center-left-buttom">
                        <el-button type="primary" round style="width:82px" size="mini">
                            查看
                        </el-button>
                    </div>
                </div>
                <div class="offer-center-right-item1" @click="goNameWelfare">
                    <div class="offer-center-right-item-title">
                        <span>工牌福利</span>
                    </div>
                    <div class="offer-center-right-item-text">
                        <span>拥有新希望工牌=超级vip卡，涵盖“医食住行购”五大类别</span>
                    </div>

                    <div class="study-center-left-buttom">
                        <el-button type="primary" round style="width:82px" size="mini">
                            查看
                        </el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
    name: "UserCenterWeal",
    data() {
        return {
            dataList: [
                {
                    icon: "",
                    title: "转正申请",
                },
                {
                    icon: "",
                    title: "离职申请",
                },
                {
                    icon: "",
                    title: "证明开具",
                },
            ],
        };
    },
    computed: {
        ...mapState({
            steps: (state) => state.guide.userSteps,
        }),
    },
    methods: {
        goInside() {
            this.$router.push("/work-portal/inside-welfare");
        },
        goNameWelfare() {
            this.$router.push("/work-portal/name-welfare");
        },
    },
};
</script>

<style lang="scss" scoped>
.user-guide-benefit-box {
    position: relative;
    z-index: 999;
    background-color: #fff;
    border-radius: 8px;
    border: 2px solid #3a9d80;
    pointer-events: none;
}
.offer-title {
    height: 50px;
    border-bottom: 1px solid #d9d9d9;
    margin-bottom: 20px;

    div {
        font-size: 16px;
        font-weight: 500;
        color: #666666;
        line-height: 22px;
        padding-top: 20px;
        padding-left: 20px;
    }
}
.offer-center {
    border-bottom: 1px solid #e1e2e3;
    display: flex;
    padding-bottom: 20px;
    margin: 0px 20px 0px 20px;

    .offer-center-right {
        display: flex;
        justify-content: space-between;

        // width: 760px;

        .offer-center-right-item {
            display: 1;
            height: 144px;
            border-radius: 4px;
            border: 1px solid #e1e2e3;
            padding: 18px 20px 12px 17px;
            margin-right: 20px;
            background-image: url("../../../../assets/pics/user-center/bjtp7.png");
            background-position-x: center;
            background-position-y: center;
            background-size: 100% 100%;
            cursor: pointer;

            .offer-center-right-item-title {
                width: 80px;

                font-size: 20px;

                font-weight: 500;
                color: #333333;
                padding-bottom: 15px;
            }
            .offer-center-right-item-text {
                width: 312px;
                font-size: 14px;
                font-weight: 400;
                color: #666666;
                padding-bottom: 15px;
            }
        }

        .offer-center-right-item1 {
            flex: 1;
            height: 144px;
            border-radius: 4px;
            border: 1px solid #e1e2e3;
            padding: 18px 20px 12px 17px;
            background-image: url("../../../../assets/pics/user-center/bj1.png");
            background-position-x: center;
            background-position-y: center;
            background-size: 100% 100%;
            cursor: pointer;

            .offer-center-right-item-title {
                width: 80px;

                font-size: 20px;

                font-weight: 500;
                color: #333333;
                padding-bottom: 15px;
            }
            .offer-center-right-item-text {
                width: 312px;
                font-size: 14px;
                font-weight: 400;
                color: #666666;
                padding-bottom: 15px;
            }
        }
    }
}
</style>
